// extracted by mini-css-extract-plugin
export default {"DetailLabel":"Typography_DetailLabel__IXJ22","DetailData":"Typography_DetailData__ftdtv"};